<template>
    <el-dialog
            :title="dataForm.id?'编辑':'新增'"
            :visible.sync="visible"
            :append-to-body="true"
            width="600px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="80px">
            <el-form-item label="业务员" prop="userId">
                <el-select v-model="dataForm.userId" filterable placeholder="请选择" style="width: 60%;" clearable
                           disabled>
                    <el-option
                            v-for="item in userList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="电话数" prop="phoneCount">
                <el-input type="text" v-model="dataForm.phoneCount" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="微信数" prop="wechatCount">
                <el-input type="text" v-model="dataForm.wechatCount" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-divider>见面数据</el-divider>
            <el-form-item label="见面数" prop="meetCount">
                <el-input type="text" v-model="dataForm.meetCount" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="meetRemark">
                <el-input type="textarea" v-model="dataForm.meetRemark"
                          :rows="5"
                          placeholder="格式（①姓名：某，电话：13524012421，见面日期：2019-07-27，客户需求：××），限500字"
                          style="width: 80%;" clearable>
                </el-input>
            </el-form-item>
            <el-divider></el-divider>
            <el-form-item label="日期" prop="tempDate">
                <el-date-picker
                        v-model="dataForm.tempDate"
                        type="datetime"
                        placeholder="选择日期时间"
                        align="right"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">保存</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import {IvUser} from "../../api/inviteUser";
    import {UdUser} from "../../api/udUser";
    import {DateFormat} from "../../utils/dateformat";

    export default {
        name: "invite-user-add-or-update",
        data() {
            let validateNumber = (rule, value, callback) => {
                let num = /^\d+$/;
                if (!num.test(value)) {
                    callback(new Error('请输入数字，非负整数！'))
                } else {
                    callback()
                }
            };
            let validateMeetRemark = (rule, value, callback) => {
                let num = value.length;
                if (num > 500) {
                    callback(new Error('内容不能超过500字'))
                } else {
                    callback()
                }
            };
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                visible: false,
                userList: [],
                dataForm: {
                    id: 0,
                    userId: '',
                    phoneCount: '',
                    wechatCount: '',
                    meetCount: '',
                    meetRemark: '',
                    tempDate: DateFormat.dateFormatTime(new Date())
                },
                dataRule: {
                    userId: [
                        {required: true, message: '请选择业务员哦', trigger: 'blur'}
                    ],
                    phoneCount: [
                        {required: true, message: '电话数不能为空', trigger: 'blur'},
                        {validator: validateNumber, trigger: 'blur'}
                    ],
                    wechatCount: [
                        {required: true, message: '微信数不能为空', trigger: 'blur'},
                        {validator: validateNumber, trigger: 'blur'}
                    ],
                    meetCount: [
                        {required: true, message: '见面数不能为空', trigger: 'blur'},
                        {validator: validateNumber, trigger: 'blur'}
                    ],
                    meetRemark: [
                        {required: true, message: '备注不能为空', trigger: 'blur'},
                        {validator: validateMeetRemark, trigger: 'blur'}
                    ],
                    tempDate: [
                        {required: true, message: '请选择日期', trigger: 'blur'}
                    ]
                }
            }
        },

        watch: {
            //弹出层关闭清空数据
            visible(newValue, oldValue) {
                if (newValue === false) {
                    this.$nextTick(() => {
                        this.$refs['dataForm'].resetFields()
                    });
                }
            }
        },

        methods: {
            //获取业务员
            getUserList() {
                UdUser.getUserList().then(res => {
                    if (res.code === 0) {
                        let userList = res.userList;
                        this.userList = [];
                        userList.forEach((item, index) => {
                            if (item.deparment === 7) { // 获取销售部人员
                                this.userList.push(item);
                            }
                        });
                    }
                })
            },

            init(id, userId) {
                this.visible = true;
                this.dataForm.id = id;
                this.getUserList();
                this.dataForm.userId = userId;
                if (this.dataForm.id) {
                    IvUser.getIvUserInfo(this.dataForm.id).then(res => {
                        if (res.code === 0) {
                            this.dataForm.userId = res.ivUser.userId;
                            this.dataForm.phoneCount = res.ivUser.phoneCount;
                            this.dataForm.wechatCount = res.ivUser.wechatCount;
                            this.dataForm.meetCount = res.ivUser.meetCount;
                            this.dataForm.meetRemark = res.ivUser.meetRemark;
                            this.dataForm.tempDate = res.ivUser.inviteDate;
                        }
                    })
                }
            },
            /**
             * 提交
             */
            dataFormSubmit() {
                let datas = {
                    'id': this.dataForm.id,
                    'userId': this.dataForm.userId,
                    'phoneCount': this.dataForm.phoneCount,
                    'wechatCount': this.dataForm.wechatCount,
                    'meetCount': this.dataForm.meetCount,
                    'meetRemark': this.dataForm.meetRemark,
                    'tempDate': this.dataForm.tempDate
                };
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let type = this.dataForm.id ? 'update' : 'save';
                        IvUser.addOrUpdateIvUser(type, datas).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$nextTick(() => {
                                            this.$emit('getDataList');
                                        })
                                    }
                                })
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    }
                });
            }
        }

    }
</script>

<style scoped>

</style>
